import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {deleteTestAction} from "features/model/slice/test/success-test/delete-test/deleteTest";


export const deleteTest = createAsyncThunk(
    "test/deleteTest",
    async (testId: string | undefined, thunkAPI) => {
        if (!testId) {
            return thunkAPI.rejectWithValue('Не удалось определить тест.');
        }

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                return thunkAPI.rejectWithValue('No token found in localStorage.');
            }
            const {token} = JSON.parse(authToken);
            const response = await axios.delete(`/api/tests/${testId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.success) {
                thunkAPI.dispatch(deleteTestAction(response.data));
                return response.data;
            }

            return thunkAPI.rejectWithValue(response.data.error || 'Ошибка удаления теста.');
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.error || 'Ошибка удаления теста.'
            );
        }
    }
);
